import { render } from "./FlowTable.vue?vue&type=template&id=60922e36&ts=true"
import script from "./FlowTable.vue?vue&type=script&lang=ts"
export * from "./FlowTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__